import * as React from 'react';
import { INumberSelector } from '../../../../interfaces/KPNumberSelector/KPNumberSelector';
import './KPNumberSelector.css'

class KPNumberSelector extends React.PureComponent<INumberSelector, any> {
    constructor(props) {
        super(props);

        this.state = {
            currentValue: this.props.currentValue ?? 0
        };

        this.handleClickUp = this.handleClickUp.bind(this);
        this.handleClickDown = this.handleClickDown.bind(this);
        this.handleNumberChange = this.handleNumberChange.bind(this);
        this.handleNumberBlur = this.handleNumberBlur.bind(this);
    }

    handleClickUp() {
        let newValue = this.state.currentValue + this.props.increment;
        if (this.props.maxValue !== undefined && newValue > this.props.maxValue) {
            newValue = this.props.maxValue;
        }
        this.setState({ currentValue: newValue });
        this.props.handleChange(newValue, this.props.valueName);
    }

    handleClickDown() {
        let newValue = this.state.currentValue - this.props.increment;
        if (this.props.minValue !== undefined && newValue < this.props.minValue) {
            newValue = this.props.minValue;
        }
        this.setState({ currentValue: newValue });
        this.props.handleChange(newValue, this.props.valueName);
    }

    handleNumberChange(e: any) {
        let newValue = e.target.value;
        if (this.props.maxValue !== undefined && newValue > this.props.maxValue) {
            newValue = this.props.maxValue;
        }
        else if (this.props.minValue !== undefined && newValue < this.props.minValue) {
            newValue = this.props.minValue;
        }
        this.setState({ currentValue: newValue });
        this.props.handleChange(newValue, this.props.valueName);
    }

    handleNumberBlur(e: any) {
        let newValue = e.target.value;
        if (newValue.toString().length === 0) {
            newValue = this.props.minValue;
            this.setState({ currentValue: newValue });
            this.props.handleChange(newValue, this.props.valueName);
        }
    }

    setValue(value: Number) {
        this.setState({ currentValue: value });
    }

    getValue(): Number {
        return this.state.currentValue;
    }

    public render() {
        return (
            <>
                <div className={"ssp-inputtextarea-container " + (this.props.className !== undefined ? this.props.className : "")}>
                    <div className="row noma">
                        <div className={"nopa ssp-inputtextarea-col-label " + (this.props.inline ? "col-8" : "col-12")}>
                            <label className="ssp-form-label ssp-opacity-1 text-left justify-content-center pt-12px">
                                {this.props.label}
                            </label>
                        </div>
                        <div className={"nopa ssp-inputtextarea-col-input input-container " + (this.props.inline ? "col-4" : "col-12")}>
                            <div className="input-selector">
                                <button className="incrementButton inputBorder numberRadiusLeft text-center" onClick={this.handleClickDown}>-</button>
                                <input type="number" pattern="[0-9]*" name={this.props.valueName}
                                    onInput={this.handleNumberChange}
                                    onBlur={this.handleNumberBlur }
                                    value={this.state.currentValue}
                                    max={this.props.maxValue} min={this.props.minValue}
                                    step={this.props.increment}
                                    className="inputBorder"
                                />
                                <button className="incrementButton inputBorder numberRadiusRight text-center" onClick={this.handleClickUp}>+</button>
                            </div>
                            {this.props.noticeMessage !== "" &&
                                <div className="ssp-inputtextarea-notice-area text-center">
                                    <span>{this.props.noticeMessage ? this.props.noticeMessage : ""}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default KPNumberSelector